
import { Avatar, Menu, MenuItem, NavBar, SubMenu, Text } from "@sede-enterprise/shell-ds-react-framework";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components";
import shell from './images/shell.svg';
import { FeatureHeadings } from './services';
import { routes } from './routes';
import { getHealthCheckUrl } from './core';

import { DefaultTheme } from 'styled-components';

const NavDiv = styled.div<{ theme: DefaultTheme }>`
  width: 100%; 
  display: flex;
  height: 72px;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  font-family: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
  background-color: ${({ theme }) => theme.background.surface};
`;

const UserMenuDiv = styled.div`
  flex: 1;
  margin-top: 6px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
`;

const SubMenuStyled = styled(SubMenu)`
    .submenu-chevron {
        margin-top: 5px;
    }
`;
const ImgStyled = styled.img`
margin-top: 10px;
margin-left:20px;
height: 58px;
width: 60px;
`;
const NavHeader = styled.div`
display: flex;
flex-flow: row nowrap;
justify-content: flex-start;
margin-right: 60px;
margin-bottom: 20px;
margin-top: 20px;
`;
const NavHeaderText = styled.div`
display: flex;
flex-flow: column nowrap;
justify-content: flex-start;
font-size: 0.85rem;
`;

const MenuLink = styled.a`
  color: white;
`;

const NavMenu: React.FC = (props) => {
  const navigate = useNavigate();
  const location = useLocation();  
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([location.pathname]);

  useEffect(() => {
    if (location.pathname === '/') {
      setDefaultSelectedKeys([routes.auctions()])
    }
  }, [location.pathname]);

  const avat = (<Avatar/>);
  const ItaMenu = (   
    <NavDiv>
      <NavHeader>             
        <ImgStyled src={shell} alt='' />
        <NavHeaderText>
          <div style={{ marginTop: "18px", marginLeft: "15px", fontWeight: "bold"}} >
            <span>Shell</span>
          </div>
          <div style={{ marginTop: "-7px", marginLeft: "15px" }}>
              <span>Interconnector Trading</span>
            </div>               
        </NavHeaderText>
        </NavHeader>
      <Menu mode='horizontal' style={{ width: '770px'}} selectedKeys={defaultSelectedKeys}
        onClick={({key}) => {setDefaultSelectedKeys([key]); navigate(key);}} defaultSelectedKeys={defaultSelectedKeys}>
          <MenuItem title={FeatureHeadings.Auctions} key={routes.auctions()}>
            {FeatureHeadings.Auctions}
        </MenuItem>
        <MenuItem title={FeatureHeadings.AuctionCalendar} key={routes.auctionCalendar()}>
          {FeatureHeadings.AuctionCalendar}
        </MenuItem>
          <SubMenuStyled title={FeatureHeadings.ConfigurationManagement} key={FeatureHeadings.ConfigurationManagement}>
            <MenuItem title={FeatureHeadings.ExchangeConfig} key={routes.exchangeConfig()}>
              {FeatureHeadings.ExchangeConfig}
            </MenuItem>
            <MenuItem title={FeatureHeadings.EtrmConfig} key={routes.etrmConfig()}>
              {FeatureHeadings.EtrmConfig}
            </MenuItem>               
          </SubMenuStyled>
      </Menu>
      <UserMenuDiv>
          <Menu mode='horizontal' selectable={false}
              onClick={({key}) => { 
                if (key === 'healthchecks') return; // External link - don't navigate
                setDefaultSelectedKeys([]); 
                navigate(key); 
              }} defaultSelectedKeys={[]}>
            <SubMenuStyled title={avat} key='AvatarMenu'>
                <MenuItem key={routes.profile()}>Profile</MenuItem>
                <MenuItem key={routes.support()}>Support</MenuItem>
                <MenuItem key={routes.help()}>Help</MenuItem>
                <MenuItem key={routes.settings()}>Settings</MenuItem>
                <MenuItem title={FeatureHeadings.HealthChecks} key="healthchecks">
                  <MenuLink href={getHealthCheckUrl()} target="_blank" rel="noopener noreferrer">
                    {FeatureHeadings.HealthChecks}
                  </MenuLink>
                </MenuItem>
            </SubMenuStyled>
          </Menu>
      </UserMenuDiv>
    </NavDiv>
  )

  return (
    ItaMenu
  )
}
export default NavMenu;


